import { FC } from 'react'
import {
    FirmViewSectionContainer,
    FlexDiv,
    OrangeButton,
    OrangeButtonOutlined
} from '../index'
import { MdOutlineDownload } from 'react-icons/md'
import { format } from 'date-fns'

interface FirmViewApplicationProps {
    onViewClick?: () => void;
    onDownloadClick?: () => void;
    dateSubmitted?: string;
}

const FirmViewApplication: FC<FirmViewApplicationProps> = ({ onViewClick, dateSubmitted, onDownloadClick }) => {

    return (
        <FirmViewSectionContainer>
            <FlexDiv justify='space-between'>
                <FlexDiv gap="84px">
                    <h1>Application</h1>
                    <FlexDiv dir='column' gap="4px">
                        <strong style={{ fontSize: '14px' }}>Date Submitted</strong>
                        <span style={{ color: '#65666A' }}>{dateSubmitted ? format(new Date(dateSubmitted), 'MM/dd/yyyy') : ''}</span>
                    </FlexDiv>
                </FlexDiv>
                <FlexDiv align='center' justify='flex-end' gap="24px">
                    <OrangeButtonOutlined style={{ padding: '8px 24px' }} onClick={onDownloadClick}>
                        <MdOutlineDownload />
                        Download
                    </OrangeButtonOutlined>
                    <OrangeButton onClick={onViewClick}>
                        View
                    </OrangeButton>
                </FlexDiv>
            </FlexDiv>
        </FirmViewSectionContainer>
    )
}

export default FirmViewApplication